import React, { useEffect, useState } from 'react';
import './CSS/About.css';
import aboutBanner from '../assets/images/about-banner.png';
import aboutBanner1 from '../assets/images/about-banner1.png';

const OtherHero = ({ heading, title, description }) => {
    const [backgroundImage, setBackgroundImage] = useState(aboutBanner);

    useEffect(() => {
        const updateBackground = () => {
            if (window.innerWidth < 768) {
                setBackgroundImage(aboutBanner1);
            } else {
                setBackgroundImage(aboutBanner);
            }
        };

        updateBackground(); // Run once on mount
        window.addEventListener('resize', updateBackground);

        return () => window.removeEventListener('resize', updateBackground);
    }, []);

    return (
        <section
            className="about-hero-section"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="container">
                <div className="about-hero-content">
                    <h1 className="about-hero-title">
                        {title}
                    </h1>
                    <p className="about-hero-subtitle">
                        {description}
                    </p>
                </div>
            </div>
        </section>
    );
};

export default OtherHero;
